import { Paragraph } from '@zillow/constellation-10';

const HandleErrorStatePage = (): JSX.Element | null => (
  <>
    <Paragraph textStyle="body-lg-bold">We can&apos;t verify your identity right now.</Paragraph>
    <Paragraph>The process we use to verify identity has failed.</Paragraph>
    <Paragraph>You can continue and finish setting up your payments.</Paragraph>
  </>
);

export default HandleErrorStatePage;
